import React from "react";
import { Platform } from "react-native";

import { ChannelListItem } from "./ChannelListItem";

import ScreenLayout from "@/Components/Layouts/Native/ScreenLayout";
import { type ChannelListProps } from "@/schemas/messaging/stream";

const PlaceholderChannelList = (_props: ChannelListProps): null => null; // eslint-disable-line @typescript-eslint/no-unused-vars

let ChannelListComponent = PlaceholderChannelList;

if (Platform.OS !== "web") {
  const { ChannelList } = require("stream-chat-expo"); // eslint-disable-line @typescript-eslint/no-var-requires
  ChannelListComponent = ChannelList;
}

type ChannelListScreenProps = {
  username: string;
};

function ChannelListScreen(
  properties: ChannelListScreenProps,
): React.JSX.Element {
  const filters = {
    members: {
      $in: [properties.username],
    },
  };

  return (
    <ScreenLayout isLoading={false}>
      <ChannelListComponent filters={filters} Preview={ChannelListItem} />
    </ScreenLayout>
  );
}

export default ChannelListScreen;
